import React from "react";
import ReportErrorHandlerModalState, { ReportErrorHandlerModalProps } from "./ReportErrorHandlerModal.models";
import { Modal } from "react-bootstrap";
import { ReportErrorCourseView } from "../submit-report/SubmitReport.models";

export default class ReportErrorHandlerModal extends React.PureComponent<ReportErrorHandlerModalProps, ReportErrorHandlerModalState>{
    render(): React.ReactNode {
        let { showModal, closeModal, notValidCourses } = this.props;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>
                            خطا
                        </label>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ textAlign: "right" }} dir={"ltr"}>
                    {this.errorListView(notValidCourses)}
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-danger tk-float-left" onClick={closeModal}>بازگشت</button>
                </Modal.Footer>
            </Modal >
        </>);
    }

    errorListView(notValidCourses: ReportErrorCourseView[]) {

        let content;
        if (notValidCourses !== null && notValidCourses.length > 0)
            content = (<> {notValidCourses.map((course, key) => {
                return (<div key={key}>
                    <div className="col-12 bd-modal" style={{ fontSize: "16px" }}>
                        <label><b>نام درس:</b>{course.courseTitle}</label>
                    </div>
                    <div className="col-12 bd-modal error">
                        {course.studyTimeHourError !== null && course.studyTimeHourError !== '' ? (<label>{course.studyTimeHourError}</label>) : ('')}
                    </div>
                    <div className="col-12 bd-modal error">
                        {course.studyTimeMinuteError !== null && course.studyTimeMinuteError !== '' ? (<label>{course.studyTimeMinuteError}</label>) : ('')}
                    </div>
                    <div className="col-12 bd-modal error">
                        {course.studyTextResultError !== null && course.studyTextResultError !== '' ? (<label>{course.studyTextResultError}</label>) : ('')}
                    </div>
                    <div className="col-12 bd-modal error">
                        {course.testPassedCountError !== null && course.testPassedCountError !== '' ? (<label>{course.testPassedCountError}</label>) : ('')}
                    </div>
                </div>);
            })}</>);
        else content = (<></>);
        return (<>
            {content}
        </>);
    }
}